import { render, staticRenderFns } from "./CandidatureCard.vue?vue&type=template&id=2ef34e98&"
import script from "./CandidatureCard.vue?vue&type=script&lang=js&"
export * from "./CandidatureCard.vue?vue&type=script&lang=js&"
import style0 from "./CandidatureCard.vue?vue&type=style&index=0&id=2ef34e98&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports